import { render, staticRenderFns } from "./BtnDropdown.vue?vue&type=template&id=0893989c&"
import script from "./BtnDropdown.vue?vue&type=script&lang=js&"
export * from "./BtnDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports